import axios from 'axios'

export const AdminPublisherService = {
  fetchPublisherList (status) {
    return axios.get(`/api/v1/publisherlist/${status}`)
  },
  addPublisherItem (data) {
    return axios.post(`/api/v1/addpublisher`, data, { headers: {
      'Content-Type': 'multipart/form-data'
    }
    }
    )
  },
  editPublisherItem (data) {
    return axios.post(`/api/v1/editpublisher`, data, { headers: {
      'Content-Type': 'multipart/form-data'
    }
    }
    )
  },
  validatePublisherItem (data) {
    return axios.delete(`/api/v1/deletepublisher`, { data: data })
  },
  deletePublisherItem (data) {
    return axios.delete(`/api/v1/deletepublisher`, { data: data })
  }
}
